import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
  HttpHeaders
} from '@angular/common/http';
import { AuthenticationService } from './authentication.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(public auth: AuthenticationService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const headers = new HttpHeaders({
      'authorization': `Bearer ${this.auth.getToken().token}`,
      'atoken': `${this.auth.getToken().atoken}`,
      'Content-Type': 'application/json'
    });
    const clonedRequest = request.clone({headers});
    console.log(clonedRequest);

    // return next.handle(request);
    return next.handle(clonedRequest).do((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        // do stuff with response if you want
      }
    }, (err: any) => {
      if (err instanceof HttpErrorResponse) {
        if (err.status === 401) {
          this.auth.logOut();
        }
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/utils/token.interceptor.ts